import { Type } from '@angular/core';
import { Routes } from '@angular/router';
import { MONTHS_ES } from '@utils/months.utils';

/** Loader típico: `() => import('.../x.component').then((m) => m.XComponent)` */

/**
 * Paths activos de "Mejores CDT del mes" (sin slash inicial), del mes actual hacia atrás.
 * Función pura compartida entre el routing de Angular y el generador de sitemap del servidor.
 */
export function getBestCdtMonthPaths(today: Date = new Date()): string[] {
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const day = today.getDate();

  // Generar paths para todos los meses del año actual hasta el mes actual
  const paths: string[] = [];
  for (let i = month; i >= 0; i--) {
    paths.push(`mejores-cdt-${MONTHS_ES[i]}-${year}`);
  }

  // Si falta 1 día o menos para el siguiente mes, agregar el path del mes siguiente
  if (daysInMonth - day <= 1) {
    let nextMonth = month + 1;
    let nextYear = year;
    if (nextMonth > 11) {
      nextMonth = 0;
      nextYear++;
    }
    paths.unshift(`mejores-cdt-${MONTHS_ES[nextMonth]}-${nextYear}`);
  }

  return paths;
}

export function getBestCdtMonthRoutes(
  loadMejoresCdtMesComponent: () => Promise<Type<unknown>>,
): Routes {
  return getBestCdtMonthPaths().map((path) => ({ path, loadComponent: loadMejoresCdtMesComponent }));
}

/* export function getBestCdtMonthRoutes(MejoresCDTsMesModuleLoader: () => Promise<any>): Routes {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const day = today.getDate();

  // Generar rutas para todos los meses del año actual hasta el mes actual
  const routes: Routes = [];
  for (let i = month; i >= 0; i--) {
    const path = `mejores-cdt-${MONTHS_ES[i]}-${year}`;
    routes.push({ path, loadChildren: MejoresCDTsMesModuleLoader });
  }

  // Si falta 1 día o menos para el siguiente mes, agregar la ruta del mes siguiente
  if (daysInMonth - day <= 1) {
    let nextMonth = month + 1;
    let nextYear = year;
    if (nextMonth > 11) {
      nextMonth = 0;
      nextYear++;
    }
    const nextPath = `mejores-cdt-${MONTHS_ES[nextMonth]}-${nextYear}`;
    routes.unshift({ path: nextPath, loadChildren: MejoresCDTsMesModuleLoader });
  }

  return routes;
} */

export function getOldBestCdtMonthRoutes(path_best_current_cdt: string): Routes {
  const oldRoutes: Routes = [];
  const currentYear = new Date().getFullYear();
  for (let year = 2021; year < currentYear; year++) {
    for (let m = 11; m >= 0; m--) {
      const mes = MONTHS_ES[m];
      oldRoutes.push({ path: `mejores-cdt-${mes}-${year}`, redirectTo: `/${path_best_current_cdt}` });
    }
  }
  return oldRoutes;
}
